export default __webpack_public_path__ + "static/media/Frame-2.53163b52.svg";